import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {ErrorStateMatcher} from '@angular/material/core';
import {Router} from '@angular/router';
import {FrontDeskService} from 'src/app/services/front-desk.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-front-desk-member',
  templateUrl: './front-desk-member.component.html',
  styleUrls: [ './front-desk-member.component.scss' ]
})
export class FrontDeskMemberComponent implements OnInit {

  public spinner: boolean;
  public memberForm: FormGroup;
  public matcher = new FormErrorStateMatcher();

  public subCategories: any[] = []
  public subCategorySelected: any = {};

  constructor (
    private dialog: MatDialog,
    public _frontDeskService: FrontDeskService,
    private router: Router,
    private snackBar: SnackBarIconService,
  ) {

    //console.log('frontDeskMember: ' + JSON.stringify(this._frontDeskService.currentMember))

    if (!this._frontDeskService.currentMember) {
      this.router.navigate([ 'front-desk' ]);
    }

    this.loadSubCategories()

    this.memberForm = this._frontDeskService.createMemberForm()
    this._frontDeskService.setMemberFormData(this.memberForm, this._frontDeskService.currentMember)

  }

  ngOnInit () {
  }

  subCategorySelectedChange (id) {
    this.subCategorySelected = this.subCategories.find((e) => {
      return e.id == id
    })
    //  console.log(JSON.stringify(this.subCategorySelected))
  }

  loadSubCategories () {

    // console.log('loadSubCategories')

    this._frontDeskService.selectSubcategoriesFrontDeskDb()
      .subscribe((result) => {
        result.forEach((item) => {

          if (
            item.id == "m6BwcqDAZMyVKJZYCWqV" ||
            item.id == "MAfkOruVx9IFvO6a2uns" ||
            item.id == "H2AoWhktluQaWYuPydHC" ||
            item.id == "ALUtUchCqgw72vtDLqfm" ||
            item.id == "AhtmJzuehg7yHhz2UFxQ" ||
            item.id == "6kopMqgiH31BYcUg5FIp" ||
            item.id == "f9IKy8nfJsjvBwO390uT" ||
            item.id == "iIZN4PMU361uYkGk9wMc"
          ) {
            this.subCategories.push({
              'id': item.id,
              'name': item.data().name,
              'documents': item.data().documents,
              'documents_en': item.data().documents_en,
              'hidden': item.data().hidden,
              'partner': item.data().partner,
              'sponsor': item.data().sponsor,
              'front_desk': item.data().front_desk,
            })
          }

        })


        // console.log('subCategories: ' + JSON.stringify(this.subCategories))
      })
  }

  getSubscriptions () {
    // this._frontDeskService.currentMember = this._frontDeskService.currentMember;
    this.router.navigate([ 'front-desk-orders' ]);
  }

  updateMember () {

    if (this.memberForm.valid) {
      this.spinner = false;

      let member = this.memberForm.getRawValue()

      // console.log("member: " + JSON.stringify(member))

      let subCategory: any = this.subCategories.find((e) => {
        return e.id == member.subCategory_id
      })

      // console.log("subCategory: " + JSON.stringify(subCategory))

      if (subCategory) {
        delete subCategory.documents
        delete subCategory.documents_en
        delete subCategory.front_desk
        delete subCategory.sponsor

        member.subCategory = subCategory
        delete member.subCategory_id
      }

      member.cellPhone = member.cellPhone
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "")
        .trim()

      member.cpf = member.cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .trim()

      console.log("member: " + JSON.stringify(member))
      console.log("currentMember before: " + JSON.stringify(this._frontDeskService.currentMember))

      this._frontDeskService.updateMember(member)
        .then(() => {
            this._frontDeskService.currentMember.name = member.name
            this._frontDeskService.currentMember.shortName = member.shortName
            this._frontDeskService.currentMember.email = member.email
            this._frontDeskService.currentMember.cellPhone = member.cellPhone
            this._frontDeskService.currentMember.cellPhonePrefix = member.cellPhonePrefix
            this._frontDeskService.currentMember.cpf = member.cpf
            this._frontDeskService.currentMember.subCategory_id = member.subCategory_id
            this._frontDeskService.currentMember.crm = member.crm
            if (member.subCategory)
              this._frontDeskService.currentMember.subCategory = member.subCategory

            console.log("currentMember after: " + JSON.stringify(this._frontDeskService.currentMember))

            this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch(() => {
          console.log("error on update member")
          this.snackBar.openSnackBar("Erro ao atualizar", '', 'error');
        })
        .finally(() => {
          this.spinner = false;
        })

    }
  }

  goBack () {
    this.router.navigate([ 'front-desk' ]);
  }

}
